import Vue from 'vue'
import '../../plugins/axios'
import App from './App.vue'
// import AppIframe from './AppIframe.vue'
import AppIframe2 from './AppIframe2.vue'
console.log(AppIframe2);

import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '../../store'
import ElementUI from 'element-ui'
import Utils from '../../script/utils.js'
import 'element-ui/lib/theme-chalk/index.css'
import 'default-passive-events'

// import Search Begin
import SearchHospitalSelect from '@/components/base/select/search/SearchHospitalSelect.js'
import SearchRoleSelect from '@/components/base/select/search/SearchRoleSelect.js'
import SearchDictItemSelect from '@/components/base/select/search/SearchDictItemSelect.js'
import SearchNormalText from '@/components/base/text/SearchNormalText.js'
import SearchDateTimeText from '@/components/base/text/SearchDateTimeText.js'

// import Search End

// import Button Begin
import SearchButton from '@/components/base/button/SearchButton/SearchButton.js'
import ImportButton from '@/components/base/button/ImportButton/ImportButton.js'
import ExportButton from '@/components/base/button/ExportButton/ExportButton.js'
import AddButton from '@/components/base/button/AddButton/AddButton.js'
import ReportButton from '@/components/base/button/ReportButton/ReportButton.js'
import SaveButton from '@/components/base/button/SaveButton/SaveButton.js'
import PrintButton from '@/components/base/button/PrintButton/PrintButton.js'
// import Button End

// import Form Begin
import FormHospitalSelect from '@/components/base/select/form/HospitalSelect.js'
import FormHospitalMultipleSelect from '@/components/base/select/form/HospitalMultipleSelect.js'
import FormRoleSelect from '@/components/base/select/form/RoleSelect.js'
import FormUserSelect from '@/components/base/select/form/UserSelect.js'
import FormDictItemSelect from '@/components/base/select/form/DictItemSelect.js'
import FormDictItemMultipleSelect from '@/components/base/select/form/DictItemMultipleSelect.js'
// import Form End

import SearchTitle from '@/components/base/frame/SearchTitle.js'
import PageHead from '@/components/base/frame/PageHead.js'

import ZPGLFormDictItemSelect from '@/components/business/select/form/DictItemSelect.js'
import ZPGLSearchDictItemSelect from '@/components/business/select/search/SearchDictItemSelect.js'

Vue.use(ZPGLFormDictItemSelect)
Vue.use(ZPGLSearchDictItemSelect)

// Vue use Search Begin
Vue.use(SearchHospitalSelect)
Vue.use(SearchRoleSelect)
Vue.use(SearchDictItemSelect)
Vue.use(SearchNormalText)
Vue.use(SearchDateTimeText)
// Vue use Search End

// Vue use Button Begin
Vue.use(SearchButton)
Vue.use(ImportButton)
Vue.use(ExportButton)
Vue.use(AddButton)
Vue.use(ReportButton)
Vue.use(SaveButton)
Vue.use(PrintButton)
// Vue use Button End

// Vue use Form Begin
Vue.use(FormHospitalSelect)
Vue.use(FormHospitalMultipleSelect)
Vue.use(FormRoleSelect)
Vue.use(FormUserSelect)
Vue.use(FormDictItemSelect)
Vue.use(FormDictItemMultipleSelect)
// Vue use Form End

// 页面标题
Vue.use(SearchTitle)
Vue.use(PageHead)

Vue.use(ElementUI, axios, VueAxios)

Vue.config.productionTip = false

// 数据交互
Vue.prototype.$http = axios
// 公共方法
Vue.prototype.$utils = Utils

//获得地址栏传参
var requestObj = new Utils.UrlSearch(); //实例化
var menuUrl = requestObj.menuUrl;
var token = requestObj.token;
var username = requestObj.username;
//如果存在地址栏路由信息，直接进入对应的路由地址
if (menuUrl) {
  let v = new Vue();
  if (!token) {
    v.$message({
      message: '用户信息失效',
      type: 'error'
    })
  } else {
    //验证Token是否合法
    if (username != sessionStorage.getItem('username')) {
      var condition = {
        username: username,
        token: token
      }
      // 设置Token
      axios.post(Utils.Url.zpgl + '/api/Login/CheckToken', condition)
        .then(res => {
          if (res.data.Code === 0) {
            console.log(res)
            // 设置Token
            sessionStorage.setItem('userid', res.data.Data.UserID)
            sessionStorage.setItem('secid', res.data.Data.SecID)
            sessionStorage.setItem('manageid', res.data.Data.ManageID)
            sessionStorage.setItem('managesecname', res.data.Data.ManageSecName)
            sessionStorage.setItem('username', res.data.Data.UserName)
            sessionStorage.setItem('truename', res.data.Data.TrueName)
            sessionStorage.setItem('roleid', res.data.Data.RoleID)
            sessionStorage.setItem('rolelevel', res.data.Data.RoleLevel)
            sessionStorage.setItem('token', res.data.Msg)
            //过滤路由数组
            let filterRouteList = [];
            //获得所有的路由
            var routes = router.options.routes;
            console.log(router.options.routes);
            //过滤出对应的路由信息
            routes.forEach(function(item) {
              if (item.path == menuUrl) {
                filterRouteList.push(item);
              }
            })
            //直接跳路由地址，不存在地址则进行提示
            if (filterRouteList.length > 0) {
              /* eslint-disable no-new */
              new Vue({
                router,
                store,
                render: h => h(filterRouteList[0].component)
              }).$mount('#main')
            } else {
              v.$message({
                message: '传递路由错误',
                type: 'error'
              })
            }
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
    } else {
      //过滤路由数组
      let filterRouteList = [];
      //获得所有的路由
      var routes = router.options.routes;
      //过滤出对应的路由信息
      routes.forEach(function(item) {
        if (item.path == menuUrl) {
          filterRouteList.push(item);
        }
      })
      //直接跳路由地址，不存在地址则进行提示
      if (filterRouteList.length > 0) {
        /* eslint-disable no-new */
        new Vue({
          router,
          store,
          render: h => h(filterRouteList[0].component)
        }).$mount('#main')
      } else {
        let v = new Vue();
        v.$message({
          message: '传递路由错误',
          type: 'error'
        })
      }
    }
  }





  //中间页面
  // sessionStorage.setItem("menuUrl",menuUrl)
  // new Vue({
  //   router,
  //   store,
  //   render: h => h(AppIframe2)
  // }).$mount('#main')

} else {
  /* eslint-disable no-new */
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#main')
}


/* eslint-disable no-new */
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#main')
